import styled from 'styled-components';

export const H5 = styled.h5`
  margin: 0;
  padding: 0;
`;

export default H5;

